// Pure helpers for video watch-progress instrumentation (spec §4).
// Kept out of the component so they are unit-testable without rendering.

// fraction (0..1) -> highest crossed milestone (0,25,50,75,100). Guards bad input.
export const computeMilestone = (fraction) => {
  const f = Number(fraction);
  if (!Number.isFinite(f) || f <= 0) return 0;
  if (f >= 1) return 100;
  if (f >= 0.75) return 75;
  if (f >= 0.5) return 50;
  if (f >= 0.25) return 25;
  return 0;
};
